var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "site-wrap" },
    [
      _c(
        "el-card",
        { staticStyle: { position: "relative" } },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTab === "0",
                  expression: "activeTab === '0'",
                },
                {
                  name: "auth",
                  rawName: "v-auth",
                  value: "storage::in-stock::in_type",
                  expression: "'storage::in-stock::in_type'",
                },
              ],
              staticStyle: {
                position: "absolute",
                right: "20px",
                top: "20px",
                "z-index": "99",
              },
              attrs: { type: "text" },
              on: { click: _vm.showTypeDialog },
            },
            [_vm._v(" " + _vm._s(_vm.$t("storage::in-stock::in_type")) + " ")]
          ),
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            _vm._l(_vm.tabs, function (item, index) {
              return _c("el-tab-pane", {
                key: index,
                attrs: { label: item.label, name: item.name },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "search-wrap" },
        [
          _vm.activeTab === "0"
            ? _c("List")
            : _vm.activeTab === "1"
            ? _c("Detail")
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.isShowDialog },
          on: {
            "update:visible": function ($event) {
              _vm.isShowDialog = $event
            },
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(" " + _vm._s(_vm.$t("storage::in-stock::in_type")) + " "),
          ]),
          _vm.isShowDialog
            ? _c("addType", {
                attrs: { type: 6 },
                on: {
                  closeDialog: function ($event) {
                    _vm.isShowDialog = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }